import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { sbnbIcon } from '@app/ui';
import { Subject } from 'rxjs';
import {
  CalendarAvailabilityOverrideReason,
  CalendarSource,
  CalendarSourceType,
} from '../../data/calendar-source.interface';

const OVERRIDES = Object.values(CalendarAvailabilityOverrideReason);
const HELP_ARTICLE_URL = 'https://help.hospitable.com/en/articles/6124538-how-are-my-calendars-synced#h_8999ec6abf';
@Component({
  standalone: false,
  selector: 'sbnb-source-label',
  templateUrl: './source-label.component.html',
  styleUrls: ['./source-label.component.scss'],
})
export class SourceLabelComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sourceData: CalendarSource[];
  @Input() type: CalendarSource['type'];
  @Input() propertyId?: string;
  @Input() tooltipPosition: 'above' | 'below' = 'below';

  public sourceDataHelpArticle = HELP_ARTICLE_URL;
  public sourceDataIcon: sbnbIcon = 'book-open';
  private destroy$ = new Subject<void>();

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.sourceDataHelpArticle = this.isCICIAvailability
      ? `/properties/property/${this.propertyId}/availability-rules`
      : HELP_ARTICLE_URL;
    this.sourceDataIcon = this.isCICIAvailability ? 'calendar-availability' : 'book-open';
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private get isCICIAvailability() {
    if (
      !this.sourceData?.length ||
      !this.propertyId ||
      (this.type !== CalendarSourceType.Availability && this.type !== CalendarSourceType.CICOAvailability)
    ) {
      return false;
    }

    const source = this.sourceData.find((source) => source.type === this.type);
    if (
      !source ||
      source.source === 'multiple' ||
      !OVERRIDES.includes(source.source as CalendarAvailabilityOverrideReason)
    ) {
      return false;
    }

    return true;
  }
}
